import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import SydSwitch from '../../../../commonDesign/SydSwitch'

function ReceiveNotificationsToggle ({ value, onChange, disabled }) {
  const handleChange = useCallback((_event, nextValue) => {
    onChange(nextValue)
  }, [onChange])

  return (
    <label
      className='flex items-center gap-2'
      style={{ cursor: disabled ? 'default' : 'pointer', userSelect: 'none', margin: 0 }}
    >
      <SydSwitch
        size='sm'
        value={value !== false}
        disabled={disabled}
        onChange={handleChange}
        label='Receive notifications'
      />
      <span className='font-size-xs' style={{ color: 'var(--color-neutral-600)' }}>
        Receive Notifications
      </span>
    </label>
  )
}

ReceiveNotificationsToggle.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

ReceiveNotificationsToggle.defaultProps = {
  value: true,
  disabled: false
}

export default ReceiveNotificationsToggle
